import React, { useEffect } from "react"
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import BaselineTableSection from "./BaselineTableSection";
import * as baselineServices from "./baselineService";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
// import * as urlService from "../../view/urlService";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Devices",
        redirectTo: "/devices",
    },
    {
        text: "Device Baseline Report",
        redirectTo: "/baseline",
    },
]

function BaselinePage(props) {
    const deviceId = props.match.params.id;
    const history = useHistory();

    useEffect(() => {
        deviceId && baselineServices.getbaselineRulesById(deviceId);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [props.baselineRules])

    useEffect(() => {
        layoutService.setPageTitle('Device Baseline Report')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            <BaselineTableSection deviceId={deviceId} />
        </>
    );
}

function mapStateToProps(state) {
    return { baselineRules: state.baselinePage.baselineRules }
}


export default withMainLayout(connect(mapStateToProps)(BaselinePage));